import BoxStatus from "@components/BoxStatus";
import ButtonContainer from "@components/ButtonContainer";
import { timestampToString } from "@helpers/dates.format";
import { IUserDetail } from "@interfaces/Core/Users/userDetail";
import { ReactElement } from "react";
import { Col } from "reactstrap";

interface IDetailUserForm {
  data: IUserDetail;
}

const DetailUserForm = ({ data }: IDetailUserForm): ReactElement => (
  <form className="form">
    <Col md={6}>
      <div className="form__form-group">
        <span className="form__form-group-label">{"Name"}</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.name} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{"Last name"}</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.lastname} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{"Username"}</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.username} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{"Mail"}</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.mail} disabled />
        </div>
      </div>
      <ButtonContainer />
    </Col>
    <Col md={6}>
      <div className="form__form-group">
        <span className="form__form-group-label">{"Created At"}</span>
        <div className="form__form-group-field">
          <input value={timestampToString(data?.createdAt)} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{"Updated At"}</span>
        <div className="form__form-group-field">
          <input value={timestampToString(data?.updatedAt)} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{"State"}</span>
        <div className="form__form-group-field">
          <BoxStatus state={data?.state ?? true} />
        </div>
      </div>
    </Col>
  </form>
);

export default DetailUserForm;
